

<template>
<div style="height: 100%;">
  <appHeader></appHeader>
  <iframe id="myIframe" :src="srcStr" style="height: calc(142% - 10vw);width: 100%;border: 0;" @onload="onloadFun">

  </iframe>
  iframe
</div>
</template>
<script>export default {
  data() {
    return {
      srcStr: ''
    };
  },
  created() {
    this.srcStr = this.$route.params.srcStr;
    setTimeout(() => {
      document.getElementById('myIframe').addEventListener('load', function() {
        document.getElementById('myIframe').contentWindow.document.getElementsByTagName('body')[0].style.zoom = '0.7';
      });
    })
  },
  watch: {
    $route(to) {
      // 监听路由变化，更新 srcStr
      this.srcStr = to.params.srcStr;
    }
  },
  methods: {
    onloadFun() {

      // iframe加载完成
    }
  }
};
</script>
<style scoped lang="scss">

</style>